import React, { useState } from 'react';
import { Container, Card, Button, Image } from 'react-bootstrap';
import { Typography, Box, Grid, Modal, Backdrop, Fade } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import image1 from '../Assist/image-1.jpg';
import image2 from '../Assist/image-2.jpg';
import image3 from '../Assist/image-3.jpg';
import image6 from '../Assist/Screenshot 2024-09-12 092415.png';
import image7 from '../Assist/Screenshot 2024-09-12 092437.png';
import logo  from '../Assist/logo.jpg'
import { Helmet } from 'react-helmet';

// Array of class base photos
const classPhotos = [
  image6,
  image1,
  image2,
  image3,
  image7,
];

const programs = [
  { title: 'A1 German Course', description: 'German language A1 class, duration 2 months.', duration: '2 months', fee: '11,000 INR', imgSrc: 'https://img.freepik.com/free-photo/ramadan-germany-flag-islamic-background_187299-37189.jpg?ga=GA1.2.1573239338.1716897012&semt=ais_hybrid' },
  { title: 'A2 German Course', description: 'German language A2 class, duration 2 months.', duration: '2 months', fee: '13,000 INR', imgSrc: 'https://img.freepik.com/free-photo/business-people-working-together_155003-14913.jpg?ga=GA1.2.1573239338.1716897012&semt=ais_hybrid' },
  { title: 'B1 German Course', description: 'German language B1 class, duration 2 months.', duration: '2 months', fee: '17,000 INR', imgSrc: 'https://img.freepik.com/free-photo/female-student-sitting-desk_23-2147844944.jpg?ga=GA1.2.1573239338.1716897012&semt=ais_hybrid' },
  { title: 'B2 German Course', description: 'German language B2 class, duration 2 months.', duration: '2 months', fee: '19,000 INR', imgSrc: 'https://img.freepik.com/free-photo/cheering-woman-holding-german-flag_23-2148935489.jpg?ga=GA1.1.1573239338.1716897012&semt=ais_hybrid' },
];

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const navigate = useNavigate();

  const handleOpen = (program) => {
    setSelectedProgram(program);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container fluid id='Gallery' className="p-4">
       <Helmet>
        <title>Course Gallery - German Language Classes</title>
        <meta name="description" content="Explore the course gallery and find the right German language course for you. A1, A2, B1, and B2 classes are available." />
        <meta name="keywords" content="German classes, A1 course, A2 course, B1 course, B2 course, language learning" />
        <meta property="og:title" content="German Language Classes" />
        <meta property="og:description" content="Learn German with our A1, A2, B1, and B2 courses. Enroll now!" />
        <meta property="og:image" content={logo} />
      </Helmet>
      {/* Display Class Base Photos at the Top */}
      <Grid container spacing={2} className="mb-4">
        {classPhotos.map((photo, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            {/* Wrap image with LazyLoad */}
            <LazyLoad height={200} offset={100} once>
              <Image
                src={photo}
                alt={`Class photo ${index + 1}`}
                style={{ width: '100%', borderRadius: '8px', objectFit: 'cover' }}
              />
            </LazyLoad>
          </Grid>
        ))}
      </Grid>

      <Box mb={4}>
        <Typography variant="h3" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'rgb(12, 12, 95)', fontFamily: 'Roboto Slab, serif' }}>
          Course Gallery
        </Typography>
        <Grid container spacing={4}>
          {programs.map((program, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card className='cardhover'>
                {/* Lazy load program images */}
                <LazyLoad height={200} offset={100} once>
                  <Card.Img variant="top" src={program.imgSrc} />
                </LazyLoad>
                <Card.Body>
                  <Card.Title style={{ fontFamily: 'Roboto Slab, serif' }}>{program.title}</Card.Title>
                  <Card.Text style={{ fontFamily: 'Roboto Slab, serif' }}>{program.description}</Card.Text>
                  <Typography variant="body2" color="textSecondary" style={{ fontFamily: 'Roboto Slab, serif' }}>
                    Duration: {program.duration}
                  </Typography>
                  <Typography variant="h6" color="rgb(12, 12, 95)" sx={{ mt: 1, fontFamily: 'Roboto Slab, serif' }}>
                    Fee: {program.fee}
                  </Typography>
                  <Button onClick={() => handleOpen(program)} className="mt-3 bgblue">
                    More Info
                  </Button>
                </Card.Body>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {selectedProgram && (
        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{ timeout: 500 }}
        >
          <Fade in={open}>
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
              borderRadius: '10px'
            }}>
              <Typography variant="h6" component="h2">
                {selectedProgram.title}
              </Typography>
              <Typography sx={{ mt: 2 }}>
                {selectedProgram.description}
              </Typography>
              <Typography sx={{ mt: 2 }}>
                Duration: {selectedProgram.duration}
              </Typography>
              <Typography sx={{ mt: 2 }}>
                Fee: {selectedProgram.fee}
              </Typography>
              <Button variant="contained" color="primary" className="mt-3 bg-success" onClick={() => navigate('/Contact Us')}>
                Contact Now
              </Button>
            </Box>
          </Fade>
        </Modal>
      )}
    </Container>
  );
};

export default Gallery;
